// src/components/Navbar.js
import { canAccessSales } from "../pages/shootSalesModel";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Navbar.css"; // 🔹 Import the matching styles

function Navbar() {
  const { currentUser, isAdmin, isSuperAdmin, logout, } = useAuth();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Left: App Title */}
        {/* <h1 className="navbar-title">VSN</h1>*/}

      

        {/* Center: Navigation Links */}
        {currentUser && (
          <ul className="navbar-menu">
            {canAccessSales(currentUser) && <li className="navbar-item"><Link to="/shoot-sales" className="navbar-link">Shoot Sales</Link></li>}
            <li className="navbar-item"><Link to="/banners" className="navbar-link">Banners</Link></li>
            <li className="navbar-item"><Link to="/my-hours" className="navbar-link">My Hours</Link></li>
            <li className="navbar-item"><Link to="/my-schedule" className="navbar-link">My Schedule</Link></li>
            <li className="navbar-item"><Link to="/dayoffrequests" className="navbar-link">Days off</Link></li>
            <li className="navbar-item">
              <Link to="/scheduler" className="navbar-link">Schedule</Link>
            </li>
            <li className="navbar-item">
              <Link to="/stafflist" className="navbar-link">Staff List</Link>
            </li>
            <li className="navbar-item">
              <Link to="/clientList" className="navbar-link">Client List</Link>
            </li>
            

            {/* Admin-only links */}
            {isAdmin && (
              <>
                <li className="navbar-item">
                  <Link to="/addClients" className="navbar-link">Add Clients</Link>
                </li>
                <li className="navbar-item">
                  <Link to="/bookappointment" className="navbar-link">Book Appointment</Link>
                </li>
                <li className="navbar-item">
                <Link to="/activityLog" className="navbar-link" >Logs</Link>
                </li>
              </>
            )}
          
            {/* Only superadmins see these links */}
            {isSuperAdmin && (
            <>
            


            <li className="navbar-item">
                  <Link to="/management" className="navbar-link">Management</Link>
                </li>
            <li className="navbar-item">    
                <Link to="/Signup"className="navbar-link">Sign Up</Link>
                </li>
            </>
            )}
            
            
          
          
          </ul>
        )}

        
        {/* Right: Login or Logout */}
        <div className="navbar-auth">

              
        
       

          {currentUser ? (
            <button className="logout-btn" onClick={logout}>Logout</button>
          ) : (
            <Link to="/login" className="login-btn">Login</Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
